import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: 'Protocolo 3C™ — Pack completo',
  ideal: 'Hombres que quieren pasar del chat a la cita de forma definitiva',
  was: 'AR$ 101.940',
  now: 'AR$ 19.990',
  features: ['Protocolo 3C completo (12 Tomos)', 'Bono #1: Kit Anti-Visto', 'Bono #2: Aperturas sin Cringe', 'Bono #3: Checklist del Chat', 'Bono #4: Guía Express de Cierre', 'Bono #5: 7 Errores Necesitado', 'Garantía 7 días incluida'],
  cta: 'Quiero aplicar el Protocolo 3C'
};
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Precios" className="bg-radial-glow" data-id="element-123" data-mp="3h5tlswgab3o1">
      <div className="mx-auto max-w-5xl px-5 py-20 pb-[23px] pt-[18px]" data-id="element-124" data-mp="3c78j8qdk87wf">
        <div className="grid place-items-center" data-id="element-125" data-mp="3vzylsdwtf31i">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5
        }} className="relative flex w-full max-w-md flex-col items-center rounded-3xl border border-gold/40 bg-ink-2 px-7 pb-7 pt-9 text-center shadow-[0_20px_60px_-20px_rgba(229,185,75,0.35)]" data-id="element-126" data-mp="3vz72a1ghsvrl">
            

            <h3 className="font-display text-xl font-black text-white" data-id="element-127" data-mp="3i791qf0uk871">{plan.name}</h3>
            <p className="mt-2 text-sm text-white/60" data-id="element-128" data-mp="3n6ljilcv2p2r">
              <span className="font-semibold text-white/80" data-id="element-129" data-mp="3n522utnamc0g">Ideal para:</span> {plan.ideal}
            </p>

            <div className="mt-6" data-id="element-130" data-mp="3rzogz4kreio8">
              <span className="text-base font-medium text-white/40 line-through" data-id="element-131" data-mp="2uizjfn2ue2kn">{plan.was}</span>
              <div className="font-display text-4xl font-black text-gold-shine" data-id="element-132" data-mp="2zh0y7vt8jfqb">{plan.now}</div>
              <p className="mt-1 text-xs font-semibold text-azul-soft" data-id="element-133" data-mp="2rgcunrx1s7to">
                Pago único · Acceso de por vida
              </p>
            </div>

            <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-134" data-mp="2mfp6rf44873o">
              {plan.features.map(f => <li key={f} className="flex items-center gap-2.5 text-sm text-white/80" data-id="element-135" data-mp="315wdwyooa3p2">
                  <CheckIcon className="h-4 w-4 shrink-0 text-gold" strokeWidth={3} data-id="element-136" data-mp="2w839ob6xjjrf" />
                  {f}
                </li>)}
            </ul>

            <div className="mt-7 w-full" data-id="element-137" data-mp="23j5s6aajlqzq">
              <CTAButton size="md" className="w-full" data-id="element-138" data-mp="23k7exc0x81xa">{plan.cta}</CTAButton>
            </div>

            <p className="mt-4 text-sm font-bold text-gold" data-id="element-139" data-mp="2igy6iz4cs9cc">Ahorrás AR$ 81.950 (80% OFF)</p>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-140" data-mp="2dg228kg3al6e">
              {trust.map(({
              icon: Icon,
              label
            }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-141" data-mp="3ovgytn4dzb0z">
                  <Icon className="h-4 w-4 text-azul-soft" data-id="element-142" data-mp="a43jr86kuox" />
                  {label}
                </span>)}
            </div>
          </motion.div>

          <div className="mt-8 flex w-full max-w-md items-start gap-3 rounded-2xl border border-azul/30 bg-azul/10 p-5 text-left" data-id="element-143" data-mp="57ds74nqx2bp">
            <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" data-id="element-144" data-mp="3rgexl3erwv6r" />
            <p className="text-sm leading-relaxed text-white/75" data-id="element-145" data-mp="3rihyiihgs8q9">
              <span className="font-bold text-white" data-id="element-146" data-mp="j1eug8dwp7gt">Garantía de devolución de 7 días.</span> Si en 7
              días no sentís que el contenido te da herramientas concretas para mejorar tus
              conversaciones y cerrar citas, pedís el reembolso. Sin vueltas y con respeto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}